export default __webpack_public_path__ + "static/media/logo-thin.74dd67a6.svg";